/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};
// 根据统一社会信用代码获取供应商
exports.getVendorBySocialCreditCode = function (params, callback) {// 根据统一社会信用代码获取供应商
    api.get('/vendor/get/by/socialCreditCode')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getVendorList = function (data, callback) {// 获取供应商列表
    api.post('/vendor/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getMerchantDtoList = function (data, callback) {// 获取供应商列表
    api.post('/vendor/merchant/dto/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getMerchantDtoListByIds = function (data, callback) {// 获取供应商列表
    api.post('/vendor/merchant/dto/list/get/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getMerchantDtoById = function (data, callback) {// 获取供应商
    api.post('/vendor/merchant/dto/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 供应商导入
exports.doVendorImpModelImport = function (data, callback) {
    api.post('/vendor/imp/model/import/do')
    .data(data)
    .done(callback)
    .go();
};
// 导入检查
exports.validateVendorImpModel = function (data, callback) {
    api.post('/vendor/imp/model/validate')
    .data(data)
    .done(callback)
    .go();
};
// 导出
exports.vendorImpModelForExport = function (data, callback) {
    api.post('/vendor/imp/model/for/export/url')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/vendor.js
// module id = 77
// module chunks = 0